import season from "../season.png";
import SidePanel from "../components/SidePanel";
import { AiOutlineCoffee } from "react-icons/ai";
import { MdOutlineWavingHand } from "react-icons/md";
import Box from "../components/Box";
import "../css/pages.css";
const FirstPage = () => {
  return (
    <>
      <div className="App-header" id="page-first">
        <img src={season} className="App-logo" alt="logo" />
        <h2>
          Hey There <MdOutlineWavingHand />
          <br />
          Have Some <AiOutlineCoffee />
        </h2>
        <Box text="play with the bubble " />
        <SidePanel />
      </div>
    </>
  );
};
export default FirstPage;
